import { useAppSelector } from 'appState/store'
import { CSV_HEADERS } from 'configs/csvHeader'
import { BatchUploadClaim } from 'features/autocheck/components'
import { IdownloadCSV } from 'features/autocheck/types'
import { useCustomerPreference } from 'features/settings/settingsHooks'
import { UserPreferencesKeysEnum } from 'features/settings/settingsTypes'
import { SettingsRequestTypeEnum } from 'features/settings/types/settingsEnum'
import { useState, useEffect } from 'react'
import { FaFileUpload, FaFileCsv } from 'react-icons/fa'
//import { Button } from "@outbound-ai/ursa"
import styled from 'styled-components'
import { longTextToSmall } from 'utils/helper'

export const AutoChecKUpload = () => {
  const currentTenant = useAppSelector((state) => state.auth.currentTenant)
  const [tenantAutoCheck, setTenantAutoCheck] = useState({
    AutoCheck: SettingsRequestTypeEnum.always,
    EOB: SettingsRequestTypeEnum.always,
    AutoCheckCalls: SettingsRequestTypeEnum.always,
  })
  const { data: tenantAutoCheckData } = useCustomerPreference(UserPreferencesKeysEnum.AutoCheckPreferences)

  useEffect(() => {
    if (tenantAutoCheckData?.value) {
      const autoCheck = JSON.parse(tenantAutoCheckData?.value)
      setTenantAutoCheck(autoCheck)
    }
  }, [tenantAutoCheckData])

  const downloadFile = (downloadData: IdownloadCSV) => {
    const blob = new Blob([downloadData.data], { type: downloadData.fileType })
    const a = document.createElement('a')
    a.download = downloadData.fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()

    const downloadData: IdownloadCSV = {
      data: [...CSV_HEADERS].join('\n'),
      fileName: 'csv_import_template.csv',
      fileType: 'text/csv',
    }
    downloadFile(downloadData)
  }
  return (
    <SideBar>
      <h1>Upload Claim File</h1>
      <p>For {currentTenant && longTextToSmall(currentTenant, 9, 18)}</p>
      <div className="upload-holder">
        <FaFileUpload />
        {tenantAutoCheck?.AutoCheck === 'always' ? (
          <p>Upload a claim file to validate and submit for batch processing</p>
        ) : (
          <p>Upload a claim file to validate for import or AutoCheck</p>
        )}
        <BatchUploadClaim />
      </div>
      <div className="helper">
        <FaFileCsv />{' '}
        <p>
          Download <a onClick={exportToCsv}>CSV Template</a>
        </p>
      </div>
    </SideBar>
  )
}

const SideBar = styled.div`
  max-width: 14rem;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin: 0 1.5rem 8.6875rem 1.5rem;
  padding: ${({ theme }) => theme.spacing.s};
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.colors.grey.lighter};
  font-family: Milliard;
  letter-spacing: normal;
  font-style: normal;
  text-align: left;

  p {
    ${({ theme }) => theme.typography.s.normal};
  }

  .helper {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    ${({ theme }) => theme.typography.xs.small};
    gap: ${({ theme }) => theme.spacing.xxs};
    p {
      ${({ theme }) => theme.typography.xs.small};
      color: ${({ theme }) => theme.colors.neutral.neutral};

      a {
        color: ${({ theme }) => theme.colors.info.neutral};
      }

      a:hover {
        color: ${({ theme }) => theme.colors.neutral.neutral};
        cursor: pointer;
      }
    }
    svg {
      color: ${({ theme }) => theme.colors.info.neutral};
    }
  }

  h1 {
    ${({ theme }) => theme.typography.m.medium};
    color: ${({ theme }) => theme.colors.neutral.neutral};
  }
  .upload-holder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: ${({ theme }) => theme.borderRadius.rounded};
    padding: ${({ theme }) => theme.spacing.s};
    text-align: center;
    border: solid 1px ${({ theme }) => theme.colors.grey.light};
    height: 240px;
    margin: ${({ theme }) => theme.spacing.s} 0px ${({ theme }) => theme.spacing.xxl} 0px;

    svg {
      color: ${({ theme }) => theme.colors.info.light};
      width: 28px;
      height: 28px;
      margin-bottom: ${({ theme }) => theme.spacing.xxxs};
    }

    p {
      ${({ theme }) => theme.typography.xs.normal};
      color: ${({ theme }) => theme.colors.grey.dark};
      margin-bottom: ${({ theme }) => theme.spacing.l};
    }
  }
`
